<template>
  <div>
    <page-header
      :actions="headerActionsConfig"
      left-side-class="col-12 col-md-7"
      :page="page"
      right-side-class="col-12 col-md-5"
    />
    <validation-observer
      v-if="!isReadOnly"
      ref="searchSSNRef"
      v-slot="{}"
      tag="form"
    >
      <div
        class="row rounded pt-2 pb-3 px-2 d-flex flex-column flex-sm-row align-items-start mx-0"
      >
        <div class="col-3" style="max-width: 300px">
          <validation-provider
            v-slot="{ errors, failedRules }"
            name="ssn"
            :rules="{ required: true, ssnpatronal: true }"
          >
            <div class="data-title">SSN Patronal:</div>
            <custom-input
              v-model="model.ssn"
              custom-error-msg=""
              :error="errors[0]"
              mask-type="SSNPatronal"
              placeholder="Escriba SSN Patronal"
              type="text"
            />
            <error
              v-if="failedRules.required"
              message="El SSN es requerido."
              variant="no-border"
            />
            <error
              v-if="failedRules.ssnpatronal"
              message="El SSN entrado no es válido."
              variant="no-border"
            />
          </validation-provider>
        </div>
        <div class="col mt-1">
          <action-button
            class="px-4 mt-4"
            i="fa fa-search"
            text="Buscar"
            variant="success"
            @click="onSearchSsnHandler()"
          />
        </div>
      </div>
    </validation-observer>
    <validation-observer
      v-if="viewProviderInfo"
      ref="providerManagementRef"
      v-slot="{}"
      tag="form"
    >
      <provider-info
        v-if="!isOpenEditProviderInfo"
        v-model="model.providerInfo"
        class="mt-4"
        :is-read-only="isReadOnly"
        :provider-types="providerTypes"
        @on-edit-provider-info="onEditProviderInfoHandler()"
      />
      <div v-if="isOpenEditProviderInfo" class="bg-light-gray rounded py-1">
        <div class="row m-2">
          <edit-provider-info
            v-model="model.providerInfo"
            :provider-types="providerTypes"
            @cancel="cancelEditProviderInfo()"
            @save="saveEditProviderInfo()"
          />
        </div>
      </div>
      <custom-tab
        v-if="isReadOnly"
        class="w-100 custom-tab-prov-management mt-3"
      >
        <custom-tab-item
          active
          :lazy="false"
          title="Información del Proveedor"
          @click="onChangeTabHandler(providerTabsEnum.PROVIDER_INFO)"
        >
          <general-information
            v-model="model.generalInformation"
            class="my-4"
            :is-read-only="isReadOnly"
          />
          <physical-address-info
            v-if="!isReadOnly"
            v-model="model.physicalAddress"
            :address-types="addressTypes"
            class="my-4"
            :municipalities="municipalities"
            :provider-id="companyId"
          />
          <div v-else class="mt-4">
            <section-title
              content="Información de Dirección"
              :has-line="true"
            />
            <div class="rounded">
              <template>
                <address-result-row
                  v-for="(row, idx) of model.addresses"
                  :key="`result-${idx}`"
                  class="mb-3"
                  :data="row"
                  @on-delete-address="deleteAddress(row)"
                  @on-edit-address="setAddressModel(row)"
                >
                  <template #default="{ addressObj }">
                    <div
                      v-if="
                        isOpenAddOrEditAddress &&
                          addressModel &&
                          addressObj.id === addressModel.id
                      "
                      class="bg-light-gray rounded py-1 mt-2"
                    >
                      <div class="m-2 bg-white">
                        <address-form-item
                          v-model="addressModel"
                          :address-types="addressTypes"
                          :address-types-excluded="addressTypesExcludedIds"
                          :location-id="location"
                          :municipalities="municipalities"
                          @cancel="cleanAddressModel"
                          @save="saveAddress"
                        />
                      </div>
                    </div>
                  </template>
                </address-result-row>
              </template>
            </div>
            <div
              v-if="isOpenAddOrEditAddress && !addressModel.id"
              class="bg-light-gray rounded py-1 mt-2"
            >
              <div class="m-2 bg-white">
                <address-form-item
                  v-model="addressModel"
                  :address-types="addressTypes"
                  :address-types-excluded="addressTypesExcludedIds"
                  :location-id="location"
                  :municipalities="municipalities"
                  @cancel="cleanAddressModel"
                  @save="saveAddress"
                />
              </div>
            </div>
            <div v-else class="d-flex flex-row-reverse">
              <action-button
                i="fas fa-file-plus"
                text="Añadir"
                variant="success"
                @click="setAddressModel()"
              />
            </div>
          </div>
          <primary-contact-info
            v-if="!isReadOnly"
            v-model="model.primaryContact"
            class="mt-4 mb-4"
            :municipalities="municipalities"
          />
          <div v-else>
            <section-title
              class="mt-4"
              content="Información de Contacto"
              :has-line="true"
            />
            <div class="rounded">
              <template>
                <contact-result-row
                  v-for="(row, idx) of primaryContact"
                  :key="`result-${idx}`"
                  class="mb-3"
                  :data="row"
                  @on-asoc-user-info="onOnAsocUserInfo(row)"
                  @on-edit-contact="onAddOrEditContactHandler(row)"
                >
                  <template #default="{ contact }">
                    <div
                      v-if="
                        isOpenAddOrEditContact &&
                          model.secondaryContact &&
                          contact.id === model.secondaryContact.id
                      "
                      class="bg-light-gray rounded py-1"
                    >
                      <div class="row m-2">
                        <add-provider-contact
                          v-model="model.secondaryContact"
                          :company-id="companyId"
                          :location-id="location"
                          :municipalities="municipalities"
                          @cancel="cancelAddorEditContact()"
                          @save="saveAddorEditContact()"
                        />
                      </div>
                    </div>
                  </template>
                </contact-result-row>
                <contact-result-row
                  v-for="(row, idx) of listWithoutPrimaryContact"
                  :key="`result-${idx}`"
                  class="mb-3"
                  :data="row"
                  @on-asoc-user-info="onOnAsocUserInfo(row)"
                  @on-delete-contact="onDeleteContactHandler(row)"
                  @on-edit-contact="onAddOrEditContactHandler(row)"
                >
                  <template #default="{ contact }">
                    <div
                      v-if="
                        isOpenAddOrEditContact &&
                          model.secondaryContact &&
                          contact.id === model.secondaryContact.id
                      "
                      class="bg-light-gray rounded py-1"
                    >
                      <div class="row m-2">
                        <add-provider-contact
                          v-model="model.secondaryContact"
                          :company-id="companyId"
                          :location-id="location"
                          :municipalities="municipalities"
                          @cancel="cancelAddorEditContact()"
                          @save="saveAddorEditContact()"
                        />
                      </div>
                    </div>
                  </template>
                </contact-result-row>
              </template>
            </div>
            <div
              v-if="!isOpenAddOrEditContact"
              class="row d-flex flex-row-reverse"
            >
              <action-button
                class="mr-3"
                i="fas fa-file-plus"
                text="Añadir"
                variant="success"
                @click="onAddOrEditContactHandler()"
              />
            </div>
            <div
              v-else-if="!model.secondaryContact.id"
              class="bg-light-gray rounded py-1"
            >
              <div class="row m-2">
                <add-provider-contact
                  v-model="model.secondaryContact"
                  :company-id="companyId"
                  :location-id="location"
                  :municipalities="municipalities"
                  @cancel="cancelAddorEditContact()"
                  @save="saveAddorEditContact()"
                />
              </div>
            </div>
          </div>
        </custom-tab-item>
        <custom-tab-item
          :active="providerTabIndex === providerTabsEnum.BIDDING_REQUEST"
          :lazy="false"
          title="Solicitud de Proponente"
          @click="onChangeTabHandler(providerTabsEnum.BIDDING_REQUEST)"
        >
          <div>
            <section-title
              class="mt-4"
              content="Listado de Solicitudes"
              :has-line="true"
            />
            <custom-result-not-found
              v-if="!model.biddingRequests.length"
              text="No se encontraron solicitudes"
            />
            <bidding-request-row
              v-for="(row, index) in model.biddingRequests"
              :key="`bidding-row-${index}`"
              :value="row"
              @on-delete="() => onDeleteBiddingHandler(row)"
              @on-enter="() => onAddBiddingHandler(row.academicYearId)"
              @on-print="() => onPrintHandler(row.academicYearId)"
              @on-print-registry="onPrintRegistryHandler(row.academicYearId)"
            />
          </div>
        </custom-tab-item>
        <custom-tab-item
          v-if="canShowBinnacle"
          :active="providerTabIndex === providerTabsEnum.Binnacle"
          :lazy="false"
          title="Bitacora"
          @click="onChangeTabHandler(providerTabsEnum.BINNACLE)"
        >
          <div>
            <section-title class="mt-4" content="Bitacora" :has-line="true" />
            <div class="rounded pt-2 pb-3 px-4">
              <validation-observer ref="binnacle" v-slot="{}" tag="form">
                <div class="row">
                  <div class="col-md-12">
                    <label class="data-title mb-0">Descripción:</label>
                    <custom-text-area
                      v-model="binnacle.comment"
                      :count-classes="['float-right']"
                      :maxlength="3000"
                      show-char-count
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <custom-file-input
                      ref="proRemfileUpload"
                      accept=".pdf"
                      display-style="normal"
                      label="Evidencia:"
                      label-position="left"
                      :on-download="onDownloadFile"
                      @input="(file) => onUploadFile(file)"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <action-button
                      class="px-4 mt-4"
                      :i="
                        binnacle.binnacleId == undefined ||
                        binnacle.binnacleId == 0
                          ? 'fa fa-plus'
                          : 'fa fa-edit'
                      "
                      :text="
                        binnacle.binnacleId == undefined ||
                        binnacle.binnacleId == 0
                          ? 'Agregar'
                          : 'Actualizar'
                      "
                      variant="success"
                      @click="addEntry()"
                    />
                  </div>
                </div>
              </validation-observer>
            </div>
            <custom-result-not-found
              v-if="binnacles == null"
              text="No se encontraron registro de bitacora"
            />
            <time-line
              v-if="binnacles != null && binnacles.length > 0"
              class="mt-4"
            >
              <div
                v-for="(item, index) in binnacles"
                :key="`item-index-${index}`"
              >
                <time-line-item class="custom-time-line rounded">
                  <template #icon>
                    <em class="radius" :class="`fal fa-comment`" />
                  </template>
                  <template #date>
                    <div class="date-container">
                      <div
                        class="color-black font-16 font-weight-bold fulldate"
                      >
                        {{ item.createDate | date }}
                      </div>
                      <div class="color-black font-12 font-weight-normal hour">
                        {{ item.createDate | hour }}
                      </div>
                    </div>
                  </template>
                  <div class="row mt-2 mx-3">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col ml-5 ml-md-6 ml-sm-0">
                          <div class="color-gray-6 font-14 font-weight-normal">
                            Creado por:
                          </div>
                          <div
                            class="color-black font-16 font-weight-normal label-value"
                          >
                            {{ item.createdBy }}
                          </div>
                        </div>
                        <div
                          v-if="item.updatedBy"
                          class="col ml-5 ml-md-6 ml-sm-0 mt-3 mt-md-0"
                        >
                          <div class="color-gray-6 font-14 font-weight-normal">
                            Actualizado Por:
                          </div>
                          <div
                            class="color-black font-16 font-weight-normal label-value"
                          >
                            {{ item.updatedBy | empty }}
                          </div>
                        </div>
                        <div
                          class="col col-sm col-12 d-flex align-items-center justify-content-end"
                        >
                          <drop-down :items="actionItems(item)" />
                        </div>
                      </div>
                      <div
                        class="row bg-white rounded p-2 mt-3 ml-5 ml-md-6 ml-sm-0"
                      >
                        <div class="col">
                          <div class="color-gray-6 font-14 font-weight-normal">
                            Comentario:
                          </div>
                          <div
                            class="color-black font-16 font-weight-normal label-value"
                          >
                            {{ item.comment }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="document in item.documents"
                        :key="document.id"
                        class="row mt-4"
                      >
                        <div class="col">
                          <div class="row">
                            <div class="col-md-6">
                              <custom-file-input
                                :attachment-id="document.id"
                                :disabled="true"
                                display-style="normal"
                                label="Archivo"
                                label-position="left"
                                :name="document.name"
                                :on-download="onDownloadFile"
                              />
                            </div>
                            <div class="col-md-4">
                              <div
                                class="color-gray-6 font-14 font-weight-normal"
                              >
                                Cargado Por:
                              </div>
                              <div>
                                {{ document.createdBy }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </time-line-item>
              </div>
            </time-line>
          </div>
        </custom-tab-item>
        <custom-tab-item
          v-if="isMedicaidDocumentationWorkflowEnabled"
          :active="providerTabIndex === providerTabsEnum.MEDICAID_ELIGIBILITY"
          title="Elegibilidad de Medicaid"
          @click="onChangeTabHandler(providerTabsEnum.MEDICAID_ELIGIBILITY)"
        >
          <medicaid-eligibility
            v-model="model.providerInfo.nationalIdentifier"
            :medical-identifier.sync="model.providerInfo.medicalIdentifier"
            :provider-id="parseInt(companyId)"
          />
        </custom-tab-item>
      </custom-tab>
      <div v-else>
        <general-information
          v-model="model.generalInformation"
          class="my-4"
          :is-read-only="isReadOnly"
        />
        <physical-address-info
          v-if="!isReadOnly"
          v-model="model.physicalAddress"
          :address-types="addressTypes"
          class="my-4"
          :municipalities="municipalities"
          :provider-id="companyId"
        />
        <div v-else class="mt-4">
          <section-title content="Información de Dirección" :has-line="true" />
          <div class="rounded">
            <template>
              <address-result-row
                v-for="(row, idx) of model.addresses"
                :key="`result-${idx}`"
                class="mb-3"
                :data="row"
                @on-delete-address="deleteAddress(row)"
                @on-edit-address="setAddressModel(row)"
              />
            </template>
          </div>
          <div
            v-if="isOpenAddOrEditAddress"
            class="bg-light-gray rounded py-1 mt-2"
          >
            <div class="m-2 bg-white">
              <address-form-item
                v-model="addressModel"
                :address-types="addressTypes"
                :address-types-excluded="addressTypesExcludedIds"
                :location-id="location"
                :municipalities="municipalities"
                @cancel="cleanAddressModel"
                @save="saveAddress"
              />
            </div>
          </div>
          <div v-else class="d-flex flex-row-reverse">
            <action-button
              i="fas fa-plus"
              text="Añadir"
              variant="success"
              @click="setAddressModel()"
            />
          </div>
        </div>
        <primary-contact-info
          v-if="!isReadOnly"
          v-model="model.primaryContact"
          class="mt-4 mb-4"
          :municipalities="municipalities"
        />
        <div v-else>
          <section-title
            class="mt-4"
            content="Información de Contacto"
            :has-line="true"
          />
          <div class="rounded">
            <template>
              <contact-result-row
                class="mb-3"
                :data="primaryContact"
                @on-edit-contact="onAddOrEditContactHandler(primaryContact)"
              />
              <contact-result-row
                v-for="(row, idx) of listWithoutPrimaryContact"
                :key="`result-${idx}`"
                class="mb-3"
                :data="row"
                @on-asoc-user-info="onOnAsocUserInfo(row)"
                @on-delete-contact="onDeleteContactHandler(row)"
                @on-edit-contact="onAddOrEditContactHandler(row)"
              />
            </template>
          </div>
          <div
            v-if="!isOpenAddOrEditContact"
            class="row d-flex flex-row-reverse"
          >
            <action-button
              class="mr-3"
              i="fas fa-plus"
              text="Añadir"
              variant="success"
              @click="onAddOrEditContactHandler()"
            />
          </div>
        </div>
        <div v-if="isOpenAddOrEditContact" class="bg-light-gray rounded py-1">
          <div class="row m-2">
            <add-provider-contact
              v-model="model.secondaryContact"
              :company-id="companyId"
              :location-id="location"
              :municipalities="municipalities"
              @cancel="cancelAddorEditContact()"
              @save="saveAddorEditContact()"
            />
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomTextArea from 'CustomTextArea';
import DropDown from 'dropdown';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomFileInput from 'CustomFileInput';
import Error from 'custom-error';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import CustomResultNotFound from 'custom-result-not-found';
import objectToFormData from 'object-to-formdata';
import AddressTypes from '@/utils/constants/addressTypes.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import {
  getMunicipalities as _getMunicipalities,
  getAddressTypes as _getAddresstypes,
  addLocationAddress as _addLocationAddress,
  editLocationAddress as _editLocationAddress,
  deleteLocationAddress as _deleteLocationAddress,
} from '@/services/common/location.api.js';
import {
  getProviderTypes as _getProviderTypes,
  getCompanyBySsn as _getCompanyBySsn,
  getCompanyById as _getCompanyById,
  saveProvider as _saveProvider,
  deleteProviderContact as _deleteProviderContact,
  getBinnacles as _getBinnacles,
  saveBinnacleEntry as _saveBinnacleEntry,
  removeBinnacleEntry as _removeBinnacleEntry,
  hasProporsalRequestSubmitted as _hasProporsalRequestSubmitted,
  syncUserInfo as _syncUserInfo,
} from '@/services/provider/provider.api.js';
import {
  getBiddingAvailableAcademicYears as _getBiddingAvailableAcademicYears,
  deleteBiddingRequest as _deleteBiddingRequest,
} from '@/services/provider/provider-bidding.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import {
  ProviderInfo,
  EditProviderInfo,
  PrimaryContactInfo,
  GeneralInformation,
  AddProviderContact,
  ContactResultRow,
  AddressResultRow,
  PhysicalAddressInfo,
  AddressFormItem,
  BiddingRequestRow,
} from './components';
import { getByParameterName } from '@/services/common/sysparameter.api';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import ReportServices from '@/services/common/report.api';
import utils from '@/utils/utilities';
import providerTypes from '@/utils/constants/providerTypes.js';
import MedicaidEligibility from './components/MedicaidEligibility.vue';

const PROVIDER_CONTRACT_DOCUMENT_ROUTE_NAME = 'ProviderContractDocument';
const PROVIDER_MANAGMENT_ROUTE_NAME = 'ProviderManagement';
const GET_REPORT_COMPANY_CONTRACTS_DETAIL = 'companyContracts';
const GET_REPORT_COMPANY_DETERMINATION_CERT =
  'companyDeterminationCertification';

const PROVIDER_TABS = {
  PROVIDER_INFO: 0,
  BIDDING_REQUEST: 1,
  BINNACLE: 2,
  MEDICAID_ELIGIBILITY: 3,
};

export default {
  name: 'ProviderManagement',
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    SectionTitle,
    CustomInput,
    ActionButton,
    Error,
    CustomTab,
    CustomTabItem,
    CustomResultNotFound,
    ProviderInfo,
    EditProviderInfo,
    PrimaryContactInfo,
    GeneralInformation,
    AddProviderContact,
    ContactResultRow,
    AddressResultRow,
    PhysicalAddressInfo,
    AddressFormItem,
    BiddingRequestRow,
    CustomTextArea,
    TimeLine,
    TimeLineItem,
    ValidationProvider,
    ValidationObserver,
    CustomFileInput,
    DropDown,
    MedicaidEligibility,
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-tie',
      title: 'Proveedor',
      routes: ['Proveedor', 'Proveedores'],
    },
    model: {
      generalInformation: {
        locationId: 0,
        websiteUrl: null,
        telephone: null,
        fax: null,
      },
      providerInfo: {
        id: null,
        ssn: null,
        ssnFormated: null,
        ssnWithoutFormat: null,
        parentMainCompanyId: null,
        providerTypeId: null,
        providerTypeName: null,
        providerType: null,
        isMainCompany: false,
        isRpProvider: false,
        isIncorporatedCompany: false,
        isServiceAssistant: false,
        providerName: null,
        nameFirst: null,
        nameLastPaternal: null,
        nameLastMaternal: null,
        nationalIdentifier: null,
        medicalIdentifier: null,
      },
      physicalAddress: {
        id: null,
        addressTypeCd: AddressTypes.Physical,
        addressTypeDescription: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        municipalityId: null,
        municipalityDescription: null,
        zipCode: null,
        latitude: null,
        longitude: null,
        additionalAnnotations: null,
        isPhysicalAddress: true,
      },
      primaryContact: {
        id: null,
        nameFirst: null,
        nameInitial: null,
        nameLastPaternal: null,
        nameLastMaternal: null,
        department: null,
        position: null,
        email: null,
        cellPhone: null,
        workPhone: null,
        fax: null,
        homePhone: null,
        municipalityId: null,
        municipalityDescription: null,
      },
      secondaryContact: {
        locationId: null,
        isPrimaryContactFlag: null,
        name: null,
        initial: null,
        lastName: null,
        secondSurname: null,
        workDepartmentName: null,
        workPositionTitle: null,
        email: null,
        telephoneMobileNo: null,
        telephoneWorkNo: null,
        telephoneWorkExtNo: null,
        telephoneWorkFaxNo: null,
        telephoneHomeNo: null,
        municipalityId: null,
        municipalityDescription: null,
      },
      biddingRequests: [],
    },
    isOpenEditProviderInfo: false,
    isOpenAddOrEditContact: false,
    isOpenAddOrEditAddress: false,
    providerTypes: [],
    municipalities: [],
    addressTypes: [],
    addressModel: {
      id: null,
      addressTypeCd: null,
      addressTypeDescription: null,
      addressLine1: null,
      addressLine2: null,
      addressLine3: null,
      municipalityId: null,
      municipalityDescription: null,
      zipCode: null,
      latitude: null,
      longitude: null,
      additionalAnnotations: null,
      isPhysicalAddress: false,
      locationId: null,
    },
    providerTabIndex: PROVIDER_TABS.PROVIDER_INFO,
    binnacles: [],
    allowedFiles: '.pdf',
    binnacle: {
      binnacleId: 0,
      comment: '',
      file: undefined,
    },
    isMedicaidDocumentationWorkflowEnabled: false,
  }),
  computed: {
    routeName() {
      return this.isReadOnly ? 'Ver' : 'Añadir';
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: this.onGoBackHandler,
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save pr-2',
          variant: 'success ml-0',
          visible:
            this.viewProviderInfo &&
            !this.isBiddingTabSelected &&
            !this.isOpenEditProviderInfo,
          click: this.onSaveHandler,
        },
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus pr-2',
          variant: 'success ml-0',
          visible: this.isBiddingTabSelected && !this.isOpenEditProviderInfo,
          click: this.onAddBiddingHandler,
        },
      ];
    },
    viewProviderInfo() {
      return this.model.providerInfo?.ssn ?? false;
    },
    companyId() {
      return this.$route.params?.companyId || this.model?.providerInfo?.id
        ? Number.parseInt(
            this.$route.params?.companyId ?? this.model?.providerInfo?.id
          )
        : null;
    },
    isReadOnly() {
      return this.companyId || this.model?.providerInfo?.id ? true : false;
    },
    saveMessage() {
      return this.isReadOnly
        ? 'El proveedor se ha actualizado exitosamente.'
        : 'El proveedor se ha creado exitosamente.';
    },
    location() {
      return this.model.generalInformation.locationId;
    },
    primaryContact() {
      return this.model.contacts.filter(
        (item) => item.isPrimaryContactFlag == true
      );
    },
    listWithoutPrimaryContact() {
      return this.model.contacts.filter(
        (item) => item.isPrimaryContactFlag !== true
      );
    },
    addressTypesExcludedIds() {
      return this.model?.addresses.map((x) => x.addressTypeCd) ?? [];
    },
    providerTabsEnum() {
      return PROVIDER_TABS;
    },
    isBiddingTabSelected() {
      return this.providerTabIndex === this.providerTabsEnum.BIDDING_REQUEST;
    },
    actionItems() {
      return (item) => {
        return [
          {
            label: 'Editar',
            icon: 'fas fa-edit color-green',
            click: () => this.onEditEntry(item),
          },
          {
            label: 'Eliminar',
            icon: 'fas fa-times-circle color-red',
            click: () => this.onRemoveEntry(item),
          },
        ];
      };
    },
    canShowBinnacle() {
      return this.userHasPermissions('rempro.provider.show.binnacle');
    },
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      next();
      await this.onLoad(to.params.companyId);
    }
  },
  async mounted() {
    await Promise.all([this.onLoad()]);
    await this.getParams();
    this.page.routes = ['Proveedor', 'Proveedores', this.routeName];
  },
  destroyed() {
    this.persistData();
  },
  watch: {
    providerTabIndex(value) {
      if (value === PROVIDER_TABS.PROVIDER_INFO) {
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: ['Proveedor', 'Proveedores', 'Editar'],
        };
      } else if (value === PROVIDER_TABS.BIDDING_REQUEST) {
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: [
            'Proveedor',
            'Proveedores',
            'Añadir Proveedor',
            'Solicitud de Proponente',
          ],
        };
      } else if (value === PROVIDER_TABS.BINNACLE) {
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: ['Proveedor', 'Proveedores', 'Añadir Proveedor', 'Bitacora'],
        };
      } else if (value === PROVIDER_TABS.MEDICAID_ELIGIBILITY) {
        this.page = {
          icon: 'fas fa-shield-alt',
          title: 'Proveedor',
          routes: [
            'Proveedor',
            'Proveedores',
            'Añadir Proveedor',
            'Elegibilidad de Medicaid',
          ],
        };
      }
    },
  },
  methods: {
    async getParams() {
      const { data } = await getByParameterName(
        'MedicaidDocumentationWorkflowEnabled'
      );

      this.isMedicaidDocumentationWorkflowEnabled =
        data?.value?.toLowerCase() === 'true';
    },
    async onLoad(companyId = null) {
      await Promise.all([
        this.getProviderTypes(),
        this.getMunicipalities(),
        this.getAddresstypes(),
        this.getProviderInformation(companyId ?? this.companyId),
      ]);
    },
    async getProviderTypes() {
      this.providerTypes = (await _getProviderTypes()).data?.filter(
        (x) => x.id != providerTypes.Asistente
      );
    },
    async getMunicipalities() {
      this.municipalities = (await _getMunicipalities()).data;
    },
    async getAddresstypes() {
      this.addressTypes = (await _getAddresstypes()).data;
    },
    async getProviderInformation(companyId) {
      if (companyId) {
        const { data } = await _getCompanyById(companyId);

        this.model = {
          ssn: null,
          generalInformation: data.generalInformation,
          physicalAddress: data.physicalAddress,
          primaryContact: data.primaryContact,
          secondaryContact: this.getCleanSecundaryContact(),
          providerInfo: {
            id: data.company.id,
            parentMainCompanyId: data.company.parentMainCompanyId,
            ssn: data.company.ssn,
            ssnFormated: data.company.ssn,
            ssnWithoutFormat: data.company.ssnWithoutFormat,
            providerName: data.company.name,
            nameFirst: data.company.nameFirst,
            nameLastPaternal: data.company.nameLastPaternal,
            nameLastMaternal: data.company.nameLastMaternal,
            providerTypeId: data.company.companyTypeCd,
            providerTypeName: data.company.companyTypeDescription,
            providerType: {
              id: data.company.companyTypeCd,
              name: data.company.companyTypeDescription,
            },
            isRpProvider: data.company.isServiceRequestCompany,
            isIncorporatedCompany: data.company.isIncorporatedCompany,
            isServiceAssistant: data.company.isServiceAssistant,
            isMainCompany: data.company.isMainCompany,
            nationalIdentifier: data.company.nationalIdentifier,
            medicalIdentifier: data.company.medicalIdentifier,
          },
          addresses: data.addresses,
          contacts: data.contacts,
          biddingRequests: data.biddingRequests,
        };
      }
    },
    async onSearchSsnHandler() {
      const isValid = await this.$refs.searchSSNRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const socialSecurityNo = this.model.ssn;

      const response = (await _getCompanyBySsn(socialSecurityNo)).data;
      if (response?.ssn) {
        const responseModal = await this.ShowCancelModal(
          'Confirmación',
          'Ya existe un proveedor definido con el número de Seguro Social Patronal entrado. ¿Desea crear el proveedor como secundario?',
          'Sí',
          'No'
        );
        if (responseModal) {
          this.model = {
            ...this.model,
            providerInfo: {
              parentMainCompanyId: response.id,
              isMainCompany: false,
              ssn: socialSecurityNo,
              isRpProvider: false,
              isIncorporatedCompany: false,
              isServiceAssistant: false,
              primaryCompanyName: response.name,
            },
          };
          this.model.ssn = null;
        }
      } else {
        this.model = {
          ...this.model,
          ssn: null,
          providerInfo: {
            parentMainCompanyId: null,
            isMainCompany: true,
            ssn: socialSecurityNo,
            isRpProvider: false,
            isIncorporatedCompany: false,
            isServiceAssistant: false,
          },
        };
      }

      this.$refs.searchSSNRef.reset();
    },
    async onSaveHandler() {
      const isValid = await this.$refs.providerManagementRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      // Si no es Individuo, o si si lo es pero no es Asistente de Servicio, se valida
      if (
        this.companyId == null &&
        (this.model.providerInfo.providerType.id !== 3 ||
          (this.model.providerInfo.providerType.id === 3 &&
            !this.model.providerInfo.isServiceAssistant))
      ) {
        const socialSecurityNo = this.model.providerInfo.ssn;
        const { canValidate, hasProporsal } = (
          await _hasProporsalRequestSubmitted(socialSecurityNo)
        ).data;

        if (
          canValidate &&
          !hasProporsal &&
          !this.model.providerInfo.isServiceAssistant
        ) {
          this.ShowToast(
            'Alerta',
            'No se identificó una propuesta sometida para el número de seguro social.',
            'error'
          );
          return;
        }
      }

      const payload = {
        generalInformation: this.model.generalInformation,
        company: {
          id: this.model.providerInfo.id,
          companyTypeCd: this.model.providerInfo.providerType.id,
          isServiceRequestCompany: this.model.providerInfo.isRpProvider,
          isIncorporatedCompany: this.model.providerInfo.isIncorporatedCompany,
          isServiceAssistant: this.model.providerInfo.isServiceAssistant,
          isMainCompany: this.model.providerInfo.isMainCompany,
          parentMainCompanyId: this.model.providerInfo.parentMainCompanyId,
          name: this.model.providerInfo.providerName,
          nameFirst: this.model.providerInfo.nameFirst,
          nameLastMaternal: this.model.providerInfo.nameLastMaternal,
          nameLastPaternal: this.model.providerInfo.nameLastPaternal,
          ssn: this.model.providerInfo.ssn,
        },
        physicalAddress: this.model.physicalAddress,
        primaryContact: this.model.primaryContact,
      };

      const { data: res } = await _saveProvider(payload).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (res?.id) {
        this.ShowToast('Proceso Exitoso', this.saveMessage, 'success');
        this.onLoadProviderHandler(res);
      }
    },
    onLoadProviderHandler({ id: companyId }) {
      if (companyId) {
        this.$router.replace({
          name: PROVIDER_MANAGMENT_ROUTE_NAME,
          params: {
            companyId,
          },
        });
      }
    },
    onEditProviderInfoHandler() {
      this.model.providerInfo.ssn = this.model.providerInfo.ssnWithoutFormat;
      this.isOpenEditProviderInfo = true;
    },
    cancelEditProviderInfo() {
      this.model.providerInfo.ssn = this.model.providerInfo.ssnFormated;
      this.isOpenEditProviderInfo = false;
    },
    saveEditProviderInfo() {
      this.isOpenEditProviderInfo = false;
      this.model.providerInfo.ssn = this.model.providerInfo.ssnFormated;
      this.getProviderInformation(this.companyId);
    },
    showAddContact(contact) {
      this.isOpenAddOrEditContact = true;
      if (contact) {
        this.model.secondaryContact = {
          id: contact.id,
          locationId: contact.locationId,
          isPrimaryContactFlag: contact.isPrimaryContactFlag,
          name: contact.nameFirst,
          initial: contact.nameInitial,
          lastName: contact.nameLastPaternal,
          secondSurname: contact.nameLastMaternal,
          workDepartmentName: contact.department,
          workPositionTitle: contact.position,
          email: contact.email,
          telephoneMobileNo: contact.cellPhone,
          telephoneWorkNo: contact.workPhone,
          telephoneWorkExtNo: contact.ext,
          telephoneWorkFaxNo: contact.fax,
          telephoneHomeNo: contact.homePhone,
          municipalityId: contact.municipalityId,
          municipalityDescription: contact.municipalityDescription,
        };
      }
    },
    cancelAddorEditContact() {
      this.isOpenAddOrEditContact = false;
      this.model.secondaryContact = this.getCleanSecundaryContact();
    },
    saveAddorEditContact() {
      this.isOpenAddOrEditContact = false;
      this.model.secondaryContact = this.getCleanSecundaryContact();
      this.getProviderInformation(this.companyId);
    },
    async onDeleteContactHandler({ id }) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar el contacto seleccionado?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const { data } = await _deleteProviderContact(id).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'El contacto ha sido eliminado exitosamente.',
          'success'
        );

      this.getProviderInformation(this.companyId);
    },
    onAddOrEditContactHandler(model = null) {
      this.isOpenAddOrEditContact = true;
      this.showAddContact(model);
    },
    async onOnAsocUserInfo(model = null) {
      if (!model.email) {
        this.ShowToast(
          'Alerta',
          'No puede asociar un contacto con el correo electrónico en blanco',
          'error'
        );
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Desea proceder con la vinculación del usuario a este contacto?`,
        'Sí',
        'No'
      );
      if (!answer) return;
      await this.syncUserInfo(model)
        .then((response) => {
          if (response) {
            this.ShowToast(
              `Confirmación`,
              'El usuario ha sido vinculado exitosamente.',
              'success'
            );
          }
          this.getProviderInformation(this.companyId);
        })
        .catch((error) => {
          this.ShowToast('', error.response?.data?.message, 'error');
        });
    },
    async syncUserInfo(model = null) {
      return _syncUserInfo(model);
    },
    setAddressModel(item = null) {
      this.isOpenAddOrEditAddress = true;
      if (item) {
        this.addressModel = { ...item };
        this.addressModel.isPhysicalAddress =
          item.addressTypeCd === AddressTypes.Physical;
      }
    },
    getCleanSecundaryContact() {
      return {
        locationId: null,
        isPrimaryContactFlag: null,
        name: null,
        initial: null,
        lastName: null,
        secondSurname: null,
        workDepartmentName: null,
        workPositionTitle: null,
        email: null,
        telephoneMobileNo: null,
        telephoneWorkNo: null,
        telephoneWorkExtNo: null,
        telephoneWorkFaxNo: null,
        telephoneHomeNo: null,
        id: null,
        municipalityId: null,
        municipalityDescription: null,
      };
    },
    cleanAddressModel() {
      this.isOpenAddOrEditAddress = false;
      this.addressModel = {
        id: null,
        addressTypeCd: null,
        addressTypeDescription: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        municipalityId: null,
        municipalityDescription: null,
        zipCode: null,
        latitude: null,
        longitude: null,
        additionalAnnotations: null,
      };
    },
    async saveAddress() {
      const existsAddress = this.model.addresses.find(
        (address) => address.addressTypeCd === this.addressModel.addressTypeCd
      );

      if (this.addressModel.id) {
        if (existsAddress && this.addressModel.id !== existsAddress.id) {
          this.ShowToast(
            'Alerta',
            `No es posible modificar el tipo de dirección a '${existsAddress.addressTypeDescription}' debido a la existencia de otra dirección del mismo tipo.`,
            'error'
          );
          return;
        }
        await this.editAddressAsync();
      } else {
        if (existsAddress) {
          this.ShowToast(
            'Alerta',
            `Ya cuenta con una dirección de tipo ${existsAddress.addressTypeDescription}.`,
            'error'
          );
          return;
        }
        await this.addAddressAsync();
      }

      await this.getProviderInformation(this.companyId);
      this.cleanAddressModel();
    },
    async addAddressAsync() {
      const payload = { ...this.addressModel, locationId: this.location };
      const { data } = await _addLocationAddress(payload).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}.`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'La dirección ha sido añadida exitosamente.',
          'success'
        );
    },
    async editAddressAsync() {
      const payload = { ...this.addressModel, locationId: this.location };
      const { data } = await _editLocationAddress(payload.id, payload).catch(
        (error) => {
          const message = error?.response?.data?.message ?? error.message;
          this.ShowToast('Alerta', `${message}.`, 'error');
          return { data: false };
        }
      );

      if (data)
        this.ShowToast(
          `Confirmación`,
          'La dirección ha sido actualizada exitosamente.',
          'success'
        );
    },
    async deleteAddress({ id, addressTypeCd, addressTypeDescription }) {
      const isPhysicalAddress = addressTypeCd === AddressTypes.Physical;
      if (isPhysicalAddress) {
        await this.ShowToast(
          'Confirmación',
          'La dirección Física no puede ser eliminada.',
          'error'
        );
        return;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar la dirección ${addressTypeDescription}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const { data } = await _deleteLocationAddress(id).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}.`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'La dirección ha sido eliminada exitosamente.',
          'success'
        );

      this.getProviderInformation(this.companyId);
    },
    async onAddBiddingHandler(academicYearId = null) {
      const academicYears = (
        await _getBiddingAvailableAcademicYears(this.companyId)
      ).data;

      if (!academicYears.length && academicYearId == null) {
        this.ShowToast(
          'Alerta',
          'No es posible crear una solicitud de proponente.',
          'error'
        );
        return;
      }

      this.$router.push({
        name: PROVIDER_CONTRACT_DOCUMENT_ROUTE_NAME,
        params: {
          companyId: this.companyId,
          academicYearId,
        },
      });
    },
    async onDeleteBiddingHandler(item) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Usted está seguro(a) que desea eliminar la solicitud ${item.requestNumber}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      const { data } = await _deleteBiddingRequest(
        item.academicYearId,
        this.companyId
      ).catch((error) => {
        const message = error?.response?.data?.message ?? error.message;
        this.ShowToast('Alerta', `${message}`, 'error');
        return { data: false };
      });

      if (data)
        this.ShowToast(
          `Confirmación`,
          'La solicitud ha sido eliminada exitosamente.',
          'success'
        );

      this.getProviderInformation(this.companyId);
    },
    async onPrintHandler(academicYearId) {
      try {
        const payload = {
          companyId: this.companyId,
          academicYearId: academicYearId,
        };

        const response = await ReportServices.getReport(
          GET_REPORT_COMPANY_CONTRACTS_DETAIL,
          payload
        );

        utils.convertToBlob(response.data);
      } catch (error) {
        this.ShowToast('', error.response?.data?.message, 'error');
      }
    },
    async onPrintRegistryHandler(academicYearId) {
      try {
        const payload = {
          companyId: this.companyId,
          academicYearId: academicYearId,
        };

        const response = await ReportServices.getReport(
          GET_REPORT_COMPANY_DETERMINATION_CERT,
          payload
        );

        utils.convertToBlob(response.data);
      } catch (error) {
        this.ShowToast('', error.response?.data?.message, 'error');
      }
    },
    async onChangeTabHandler(tabIndex) {
      this.providerTabIndex = tabIndex;
      if (tabIndex == PROVIDER_TABS.BINNACLE) {
        await this.getEntries();
      }
    },
    resetData() {
      Object.assign(this.$data, this.$options.data());
    },
    onGoBackHandler() {
      this.providerTabIndex = PROVIDER_TABS.PROVIDER_INFO; //set default tab before move on
      this.resetData(); //reset to initial component data
      this.$router.push('/provider/provider-search');
    },
    async addEntry() {
      const isValid = await this.$refs.binnacle.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
      } else {
        var entry = {
          ...this.binnacle,
          companyId: this.companyId,
        };
        let dataTosend = objectToFormData(entry, {
          indices: true,
          nullsAsUndefineds: true,
        });

        var result = await _saveBinnacleEntry(dataTosend);
        if (result) {
          this.ShowToast('Alerta', 'Se ha guardado la entrada.', 'success');
          await this.getEntries();
          this.binnacle.binnacleId = null;
          this.binnacle.comment = '';
          this.binnacle.file = undefined;
          this.$refs.binnacle.reset();
        }
      }
      return false;
    },
    async getEntries() {
      this.binnacles = (await _getBinnacles(this.companyId)).data || [];
    },
    onDownloadFile(id) {
      _downloadDocumentByAttachmentId(id).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });
    },
    onUploadFile(file) {
      this.binnacle.file = file;
    },
    onEditEntry(item) {
      this.binnacle.binnacleId = item.binnacleId;
      this.binnacle.comment = item.comment;
      return false;
    },
    async onRemoveEntry(item) {
      var result = await _removeBinnacleEntry(item.binnacleId);
      if (result) {
        this.ShowToast('Alerta', 'Se ha eliminado la entrada.', 'success');
        await this.getEntries();
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.custom-tab-prov-management ::v-deep {
  .custom-tab-container {
    margin-left: 1px !important;
    margin-right: 1px !important;
    .nav-item {
      .nav-link {
        &.active {
          border-bottom: 3px solid map-get($colors, 'orange') !important;
          color: map-get($colors, 'orange') !important;
        }
      }
    }
  }
}
</style>
